import { Avatar as AntdAvatar, AvatarProps as AntdAvatarProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface AvatarProps extends AntdAvatarProps {}

export const avatarPrefixCls = `${CMP_PREFIX}-avatar`;

export const Avatar = ({ ...props }: AvatarProps) => {
  return <AntdAvatar {...props} />;
};
